<div class="gw-w-full gw-mx-auto">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="gw-space-y-6">
    <div class="gw-space-y-4 gw-p-x-large">
      <p class="gw-text-text-primary gw-text-base">
        {{
          'features.settings.parameters.' + setting.key + '.description'
            | translate
        }}
      </p>
      <div class="gw-space-y-2">
        <label
          class="gw-block gw-text-[14px] gw-font-medium gw-text-text-primary"
        >
          {{
            ('features.settings.parameters.' + setting.key + '.label'
              | translate) || setting.key
          }}
        </label>
        <select
          formControlName="provider"
          class="gw-w-full gw-px-3 gw-py-2 gw-border gw-border-border-normal gw-rounded-[4px] gw-text-[16px] gw-text-text-primary focus:gw-outline-none focus:gw-border-primary gw-bg-background-primary"
        >
          <option value=""></option>
          <ng-container *ngFor="let provider of availableProviders">
            <option [value]="provider">
              {{ getProviderLabel(provider) }}
            </option>
          </ng-container>
        </select>
      </div>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3">
      <gatewee-button
        variant="outline"
        [title]="'general.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'general.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
